import { render, staticRenderFns } from "./PanelCustomerAccessRequest.vue?vue&type=template&id=6859a388&scoped=true&"
import script from "./PanelCustomerAccessRequest.vue?vue&type=script&lang=ts&"
export * from "./PanelCustomerAccessRequest.vue?vue&type=script&lang=ts&"
import style0 from "./PanelCustomerAccessRequest.vue?vue&type=style&index=0&id=6859a388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859a388",
  null
  
)

export default component.exports